import {connect} from "react-redux"
import {BundleSummaryData} from "../../models/searchApi/bundle"
import State from "../../models/state"
import {
    formatPdpLink,
    formatBundleTitle,
    formatBundleTooltipTitle,
    bundlePriceComponentAriaLabelText,
} from "../../utils/colourwayBuilders"

export const mapStateToProps = (state: State) => {
    const {
        template,
        productSummary: {colourwaysHasSale, brandedMarkdownSalePrice},
        text,
        request: {isEnglishLang},
    } = state
    const {
        colourways,
        title: defaultTitle,
        baseUrl,
        fit,
        bundlePriceLabel,
    } = state.productSummary.summaryData as BundleSummaryData
    const associatedColourwayHasSale = colourways.some(colourway => Boolean(colourway?.associatedColourway?.salePrice))
    const selectedColourway = colourways.find(colourway => colourway.s)
    const basesHasSale = colourwaysHasSale
    const shadesHasSale = associatedColourwayHasSale
    const {
        t: title,
        id: colourwayItemNumber,
        p: price,
        wp: wasPrice,
        sp: salePrice,
        url,
        bundlePrice,
        wasBundlePrice,
        saleBundlePrice,
        associatedColourway,
    } = selectedColourway as any

    const bundleTitle = formatBundleTitle({
        title,
        defaultTitle,
        fit,
        selectedColourway,
        isEnglishLang,
    })

    const sharedAriaParams = {
        title: bundleTitle,
        wasPriceText: text.price.was,
        salePriceText: text.price.now,
        isEnglishLang,
        basesHasSale,
        shadesHasSale,
    }

    return {
        templating: {
            ...template,
        },
        tooltipTitle: formatBundleTooltipTitle({
            title,
            defaultTitle,
            colourwayItemNumber,
            price,
            salePrice,
            fit,
            selectedColourway,
            isEnglishLang,
        }),
        linkUrl: formatPdpLink(baseUrl, url),
        basePrice: price,
        wasBasePrice: wasPrice,
        saleBasePrice: salePrice,
        bundlePrice,
        wasBundlePrice,
        saleBundlePrice,
        shadePrice: associatedColourway?.price,
        wasShadePrice: associatedColourway?.wasPrice,
        saleShadePrice: associatedColourway?.salePrice,
        text,
        basesHasSale,
        shadesHasSale,
        bundlePriceAriaLabel: bundlePriceComponentAriaLabelText({
            ...sharedAriaParams,
            price: bundlePrice,
            wasPrice: wasBundlePrice,
            salePrice: saleBundlePrice,
            priceText: "Price",
        }),
        bundleBasePriceAriaLabel: bundlePriceComponentAriaLabelText({
            ...sharedAriaParams,
            price,
            wasPrice,
            salePrice,
            priceText: "Base Price",
        }),
        bundleShadesPriceAriaLabel: bundlePriceComponentAriaLabelText({
            ...sharedAriaParams,
            price: associatedColourway?.price,
            wasPrice: associatedColourway?.wasPrice,
            salePrice: associatedColourway?.salePrice,
            priceText: "Shades Price",
        }),
        brandedMarkdownSalePrice,
        bundlePriceLabel,
    }
}

export default connect(mapStateToProps)
